import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Products from 'merchandise-lib/constants/Product';
import { jsx as _jsx } from "react/jsx-runtime";
export const getI18nKeyOverrideForProductCard = apiName => {
  switch (apiName) {
    case Products.MARKETING_PLUS_SUITE_BUNDLE_PROFESSIONAL:
      return {
        Title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.productTile.marketing-plus-professional-bundle.title"
        }),
        Description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.productTile.marketing-plus-professional-bundle.description"
        }),
        LowerTierPlus: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.productTile.marketing-plus-professional-bundle.lowerTierPlus"
        })
      };
    case Products.MARKETING_PLUS_SUITE_BUNDLE_ENTERPRISE:
      return {
        Title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.productTile.marketing-plus-enterprise-bundle.title"
        }),
        Description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.productTile.marketing-plus-enterprise-bundle.description"
        }),
        LowerTierPlus: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.productTile.marketing-plus-enterprise-bundle.lowerTierPlus"
        })
      };
    case Products.CRM_SUITE_STARTER_BUNDLE:
      return {
        Title: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "pricing-pages-ui.merchCardsV2.customerPlatform.starterCard.title"
        }),
        Description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.suiteTile.starterCard.description"
        })
      };
    case Products.HUBSPOT_FREE:
      return {
        Title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.suiteTile.freeCard.title"
        }),
        Description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.suiteTile.freeCard.description"
        })
      };
    case Products.CORE_SEATS_PROFESSIONAL:
      return {
        Title: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "pricing-pages-ui.merchCardsV2.smartCrm.professionalCard.title"
        }),
        Description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.productTile.core-seats-professional.description"
        }),
        LowerTierPlus: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.productTile.core-seats-professional.lowerTierPlus"
        })
      };
    case Products.CORE_SEATS_ENTERPRISE:
      return {
        Title: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "pricing-pages-ui.merchCardsV2.smartCrm.enterpriseCard.title"
        }),
        Description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.productTile.core-seats-enterprise.description"
        }),
        LowerTierPlus: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.productTile.core-seats-enterprise.lowerTierPlus"
        })
      };
    case Products.COMMERCE_HUB_PROFESSIONAL:
      return {
        Title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.productTile.commerce-hub-professional.title"
        }),
        Description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.productTile.commerce-hub-professional.description"
        }),
        LowerTierPlus: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.productTile.commerce-hub-professional.lowerTierPlus"
        })
      };
    case Products.COMMERCE_HUB_ENTERPRISE:
      return {
        Title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.productTile.commerce-hub-enterprise.title"
        }),
        Description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.productTile.commerce-hub-enterprise.description"
        }),
        LowerTierPlus: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.productTile.commerce-hub-enterprise.lowerTierPlus"
        })
      };
    default:
      return undefined;
  }
};